import {t} from "@lingui/core/macro";
import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {CircularSpinner} from "@khanacademy/wonder-blocks-progress-spinner";

const ProfileContentChrome = (): React.ReactElement => (
    <>
        {/* The JS for other profile tabs will modify this header */}
        <h1 className="sr-only ka-tab-header">{t`Dashboard`}</h1>
        <h2 className="sr-only ka-tab-subheader">{t`Personal Dashboard`}</h2>
        <div id="dashboard-root" />
        <div id="profile-spinner" className="profile-spinner">
            <View style={{alignItems: "center"}}>
                <CircularSpinner />
            </View>
        </div>
        {/*  More container divs may be inserted here via JS for the other profile
           tabs, such as Badges, Activity, etc. */}
    </>
);

export default ProfileContentChrome;
